import { atomWithReset } from "jotai/utils"

export interface FormDataInterface {
  projectName: string
  projectAddress: string
  companyName: string
  companyAddress: string
  revision: string
  companyLogo: string
  dateCreated: number
  dateModified: number
}

export const formData = atomWithReset<FormDataInterface>({
  projectName: "",
  projectAddress: "",
  companyName: "",
  companyAddress: "",
  revision: "",
  companyLogo: "",
  dateCreated: 0,
  dateModified: 0
})
